<mat-drawer-container class="example-container" style="min-height: 34rem;">
  <mat-drawer mode="side" opened class="custom-mat-drawer">
    <div class="drawerContent" id="leftPannel">
      <mat-list role="list">

        <!-- <mat-list-item style="cursor: pointer;padding-bottom: 10px;" *ngIf="showLegacy" [routerLink]="['../legacy-extract']" routerLinkActive="activeLink" #rlaLegacy="routerLinkActive" (click)="maskPage()">
          <img alt="img" matListAvatar src="{{'./assets/legacy_active.svg'}}" class="imgsize">
          <h3 matLine [ngClass]="{headerText: rlaLegacy.isActive}"> Legacy Extract &  </h3>
          <h3 matLine [ngClass]="{headerText: rlaLegacy.isActive}"> Transform </h3>
          <mat-divider [ngClass]="{activeline: rlaLegacy.isActive}"></mat-divider>
        </mat-list-item> -->
<!-- 
        <mat-list-item style="cursor: pointer;padding-bottom: 10px;" *ngIf="!showLegacy" [routerLink]="['../legacy-extract']" routerLinkActive="activeLink" #rlaLegacy="routerLinkActive" (click)="maskPage()">
          <img alt="img" matListAvatar src="{{'./assets/legacy_active.svg'}}" class="imgsize">
          <h3 matLine > Legacy Extract & Transform </h3>
          <mat-divider [ngClass]="{activeline: rlaLegacy.isActive}"></mat-divider>
        </mat-list-item> -->

        <mat-list-item style="cursor: pointer;padding-bottom: 10px;" [routerLink]="['../cloud-extract']" routerLinkActive="activeLink" #rlaExtract="routerLinkActive" (click)="maskPage()">
          <img alt="img" matListAvatar src="{{'./assets/cloudExtract_active.svg'}}" class="imgsize">
          <h3 matLine [ngClass]="{headerText: rlaExtract.isActive}"> Cloud Extract </h3>
          <mat-divider [ngClass]="{activeline: rlaExtract.isActive}"></mat-divider>
        </mat-list-item>

        <mat-list-item style="cursor: pointer;padding-bottom: 10px;" [routerLink]="['../config-workbook']" routerLinkActive="activeLink" #rlaWorkbook="routerLinkActive" (click)="maskPage()">
          <img alt="img" matListAvatar src="{{'./assets/workbook_active.svg'}}" class="imgsize">
          <h3 matLine  [ngClass]="{headerText: rlaWorkbook.isActive}"> Config Workbook </h3>
          <mat-divider [ngClass]="{activeline: rlaWorkbook.isActive}"></mat-divider>
        </mat-list-item>

        <mat-list-item style="cursor: pointer;padding-bottom: 10px;" [routerLink]="['../cloud-load']" routerLinkActive="activeLink" #rlaCloud="routerLinkActive" (click)="maskPage()">
          <img alt="img" matListAvatar src="{{'./assets/cloudLoad_active.svg'}}" class="imgsize">
          <h3 matLine  [ngClass]="{headerText: rlaCloud.isActive}"> Cloud Load </h3>
          <mat-divider [ngClass]="{activeline: rlaCloud.isActive}"></mat-divider>
        </mat-list-item>

        <mat-list-item style="cursor: pointer;padding-bottom: 10px;" [routerLink]="['../config-compare']" routerLinkActive="activeLink" #rlaCompare="routerLinkActive" (click)="maskPage()">
          <img alt="img" matListAvatar src="{{'./assets/compare_active.svg'}}" class="imgsize">
          <h3 matLine  [ngClass]="{headerText: rlaCompare.isActive}"> Config Compare </h3>
          <mat-divider [ngClass]="{activeline: rlaCompare.isActive}"></mat-divider>
        </mat-list-item>
<!-- 
        <mat-list-item style="cursor:not-allowed; color:#fbfbfb61;padding-bottom: 10px;" >
          <img alt="img" matListAvatar src="{{'./assets/metadata_disable.svg'}}" class="imgsize">
          <h3 matLine style="color: #9F9F9F;"> Metadata Insights </h3>
          <mat-divider [ngClass]="{activeline: false}"></mat-divider>
        </mat-list-item> -->
        
        <mat-list-item *ngIf="showConfigBuild" style="cursor: pointer; padding-bottom: 10px;" [routerLink]="['../config-build']" routerLinkActive="activeLink" #rlaBuild="routerLinkActive" (click)="maskPage()">
          <img alt="img" matListAvatar src="{{'./assets/compare_active.svg'}}" class="imgsize">
          <h3 matLine [ngClass]="{headerText: rlaBuild.isActive}"> Predicted Configurations</h3>
          <mat-divider [ngClass]="{activeline: rlaBuild.isActive}"></mat-divider>
      </mat-list-item>
      </mat-list>
    </div>
  </mat-drawer>

  <mat-drawer-content class="setBackground">
    <router-outlet></router-outlet>
  </mat-drawer-content>

</mat-drawer-container>
